export default {
  onSubmitSuccessToastMessage: 'Your changes have been successfully saved.',
};
